<template>
  <div class="area-warp">
    <div class="city-name" @click="selectCity">
      <i class="crm-location"></i>
      <span>{{ getCitylabel }}</span>
      <i class="icon-outlinedpickup"></i>
    </div>
    <tree-select
      :options="options"
      :value="commonAreaChecked"
      @input="(v) => $emit('areaChange', v)"
    />
  </div>
</template>
<script>
import treeSelect from '@/components-new/treeSelect/index.vue'
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'areaTree',
  components: { treeSelect },
  props: {
    options: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      defaultValue: ['allChild']
    }
  },
  watch: {
    commonAreaChecked: {
      deep: true,
      handler(v) {
        console.log(v, '更改的值')
      }
    }
  },
  computed: {
    ...mapState('bizoppV2', [
      'commonAreaChecked',
      'commnoCityAreaTree',
      'commonCityChecked'
    ]),
    getCitylabel() {
      return this.commnoCityAreaTree.length && this.commonCityChecked.value
        ? this.commnoCityAreaTree.find(
            (item) => item.id === this.commonCityChecked.value
          ).label
        : ''
    }
  },
  methods: {
    ...mapMutations('bizoppV2', ['updateCommonAreaChecked']),
    getAreaCheckout() {
      console.log(this.defaultValue, 'defaultValue')
    },
    selectCity() {
      this.$emit('cityPopupShow')
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .rich-picker-choose {
  display: none;
}
.area-warp {
  .city-name {
    font-family: Aspira-Demi;
    font-size: 36px;
    color: #000000;
    text-align: center;
    line-height: 44px;
    font-weight: normal;
    border-radius: 24px 24px 0 0;
    padding: 30px 0;
    .crm-location {
      margin-right: 8px;
      color: #ff7a45;
      vertical-align: middle;
    }
    .icon-outlinedpickup {
      font-size: 32px;
      margin-left: 4px;
      vertical-align: middle;
    }
  }
}
</style>
